import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PHOTOS_PER_PAGE = 15;
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const allWeddingPhotos = [
  // Page 1
  { id: 1, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4662cda3df1dff9b29dca447dc95d9d5.jpeg', title: '誓いの瞬間' },
  { id: 2, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/30634fbca392c5f1cd7beff2e1efe888.jpeg', title: '白無垢' },
  { id: 3, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/0d8359dccc1caccd626d762cf32c86fd.jpeg', title: '庭園の散歩' },
  { id: 4, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/f143cbd3f527428d69eaf378a7398c11.jpeg', title: '永遠の約束' },
  { id: 5, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/e6c0cf566e4045d44a626a9344250184.jpeg', title: '披露宴' },
  { id: 6, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/20ced4381a3de88ff741808c8d51c624.jpeg', title: 'ファーストダンス' },
  { id: 7, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/29903d7d71b0e5827ab615968c1c6037.jpeg', title: '支度' },
  { id: 8, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/a1671f191b3c39701e5394b27e264273.jpeg', title: '夕暮れの二人' },
  { id: 9, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/17b78f73ef8c3d54d70c22852ba4183e.jpeg', title: 'ブーケ' },
  { id: 10, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/8ec23e3479fdb06f405ba635d8adbb9f.jpeg', title: '神前式' },
  { id: 11, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/0d04233097f2b035dbe1119fb672bfb8.jpeg', title: '桜の下で' },
  { id: 12, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/97468ed65895b5a11ee1c677887e0b83.jpeg', title: 'ウェディングケーキ' },
  { id: 13, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/cac11ae5ed1fd7e5c89f93942261d623.jpeg', title: '誓いの言葉' },
  { id: 14, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/aa10a7e9899efd6a0b46d31d3ce6319e.jpeg', title: '祝福の瞬間' },
  { id: 15, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/19314c9d20c2832ddf4c4e621313a519.jpeg', title: 'ドレスの詳細' },
  // Page 2
  { id: 16, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/601ae4d161edd6f8d0aea34ebfc3cb47.jpeg', title: '海辺の二人' },
  { id: 30, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/f4bda4d05862b3b9519728f1112b5e8f.jpeg', title: '色打掛' },
  { id: 17, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/349751df747dac006a3b6957bdcf4447.jpeg', title: 'ブライダルポートレート' },
  { id: 18, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/16f984ffb94c3ca650249ef090f9e8c4.jpeg', title: 'バージンロード' },
  { id: 19, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/8c05315a83446a92141f9bb9a369a354.jpeg', title: 'ヴェールの調整' },
  { id: 20, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/7e4c089042f132313186b3cceb303d49.jpeg', title: 'テーブルコーディネート' },
  { id: 21, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/3ebc6bce074549f4644c1f065db148fb.jpeg', title: 'ファーストキス' },
  { id: 22, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/625386dde0dd51d052676464c3b709c2.jpeg', title: '竹林の二人' },
  { id: 23, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/2f084699ef445b0e5c37ea55b9f2a547.jpeg', title: '招待状' },
  { id: 24, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/d1779c6c6f045a6e4edf633e6b5c18df.jpeg', title: 'ブライズメイド' },
  { id: 25, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/377230cbee01bac3df307de10bc870c9.jpeg', title: '紅葉の中で' },
  { id: 26, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/eaa2eed4a0fd3275797fd326aa3aa35c.jpeg', title: '花嫁の手' },
  { id: 27, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/a6978c6dccbd1a696d6e2deb921bea94.jpeg', title: '三三九度' },
  { id: 28, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4bd3f69600712437b8c7447542c20368.jpeg', title: '会場の夜景' },
  { id: 29, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/9bb0946ba2e009e0c8b79f5ebd19972d.jpeg', title: 'ケーキカット' },
  // Page 3
  { id: 31, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/7631ce380088d7df6572d349f9d08e0d.jpeg', title: '鳥居をくぐる' },
  { id: 32, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/94515cb26550e67e0da20d68ae739979.jpeg', title: '髪飾り' },
  { id: 33, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/1e024b6729df5f49c105f57bfe626f75.jpeg', title: '雨の日の二人' },
  { id: 34, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4b328a89e41f537bd8449e257a9d64ac.jpeg', title: 'スイーツビュッフェ' },
  { id: 35, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/50e12dc15911993197d824ad801c512f.jpeg', title: 'お城での撮影' },
  { id: 36, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/cc0274e4df66fa08ab2770712aa3ec09.jpeg', title: 'スパークラー' },
  { id: 37, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/4e95b92252ba1a64831d35f824078f05.jpeg', title: '三三九度の儀' },
  { id: 38, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/1b5de2b9c403dd2488767fb67cbcdb65.jpeg', title: 'ラベンダー畑' },
  { id: 39, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/47debf31b38176ce0fa56278fed82c44.jpeg', title: 'メイクアップ' },
  { id: 40, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/807b2703d375a3b45658d018e8d0b946.jpeg', title: '星空の下で' },
  { id: 41, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/121c69b498f72f0b5278ddbeccbdb4d4.jpeg', title: '神主の祝詞' },
  { id: 42, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/fc54a2138d645882aaed3a082629341a.jpeg', title: '雪の結婚式' },
  { id: 43, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/a31c44243140be40f048727425b3d358.jpeg', title: 'スピーチ' },
  { id: 44, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/52b8652612abf9a3c08bbe35ea73472a.jpeg', title: 'ドレスの刺繍' },
  { id: 45, url: 'https://static.readdy.ai/image/bbbff43ff07d452d166ab0b0917c289c/0f7b147f425c5fba924b61dbb9529203.jpeg', title: '黄金の時間' },
];

function WeddingJsonLd() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      '@id': `${SITE_URL}/portfolio/wedding#webpage`,
      url: `${SITE_URL}/portfolio/wedding`,
      name: 'Wedding Photography | KAZU.PHOTO – 石川県金沢市 ウェディング撮影ギャラリー',
      description: '石川県金沢市のフォトグラファーKAZU.PHOTOによるウェディング撮影ポートフォリオ。神前式・白無垢・ドレス・披露宴など45枚以上の作品集。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
          { '@type': 'ListItem', position: 2, name: 'Portfolio', item: `${SITE_URL}/portfolio/wedding` },
          { '@type': 'ListItem', position: 3, name: 'Wedding', item: `${SITE_URL}/portfolio/wedding` },
        ],
      },
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'jsonld-wedding';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { script.parentNode?.removeChild(script); };
  }, []);
  return null;
}

export default function WeddingGallery() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(allWeddingPhotos.length / PHOTOS_PER_PAGE);
  const startIndex = (currentPage - 1) * PHOTOS_PER_PAGE;
  const currentPhotos = allWeddingPhotos.slice(startIndex, startIndex + PHOTOS_PER_PAGE);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openLightbox = (index: number) => {
    setSelectedImage(startIndex + index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction: 'prev' | 'next') => {
    if (selectedImage === null) return;
    if (direction === 'prev') {
      setSelectedImage(selectedImage === 0 ? allWeddingPhotos.length - 1 : selectedImage - 1);
    } else {
      setSelectedImage(selectedImage === allWeddingPhotos.length - 1 ? 0 : selectedImage + 1);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="bg-white min-h-screen">
      <WeddingJsonLd />
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
          scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-white'
        }`}
      >
        <div className="flex items-center justify-between px-8 lg:px-16 py-6">
          <Link
            to="/"
            className="text-xs tracking-[0.2em] font-light text-stone-900 hover:text-stone-600 transition-colors"
          >
            KAZU.PHOTO
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-xs tracking-[0.2em] font-light text-stone-600 hover:text-stone-900 transition-colors"
          >
            <i className="ri-arrow-left-line" />
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-32 pb-20 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <span className="text-[10px] tracking-[0.3em] text-stone-400 uppercase mb-4 block">
            Portfolio
          </span>
          <h1 className="text-5xl md:text-6xl font-extralight tracking-wide text-stone-900 mb-4">
            Wedding
          </h1>
          <p className="text-sm text-stone-500 font-light tracking-wide">
            永遠の愛を形に
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="pb-16 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentPhotos.map((photo, index) => (
              <div
                key={photo.id}
                onClick={() => openLightbox(index)}
                className="group cursor-pointer relative overflow-hidden rounded-2xl bg-stone-100"
              >
                <div className="w-full flex items-center justify-center min-h-[300px] overflow-hidden">
                  <img
                    src={photo.url}
                    alt={photo.title}
                    className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-search-line text-white text-3xl" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-center gap-6 mt-16 mb-16">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="w-10 h-10 flex items-center justify-center text-stone-400 hover:text-stone-900 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg" />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`w-10 h-10 flex items-center justify-center text-xs tracking-[0.2em] transition-all duration-300 cursor-pointer rounded-full ${
                  currentPage === page
                    ? 'bg-stone-900 text-white'
                    : 'text-stone-500 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                {page}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="w-10 h-10 flex items-center justify-center text-stone-400 hover:text-stone-900 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-lg" />
            </button>
          </div>

          {/* Page indicator */}
          <p className="text-center text-[10px] tracking-[0.3em] text-stone-400 uppercase mb-16">
            {startIndex + 1} – {Math.min(startIndex + PHOTOS_PER_PAGE, allWeddingPhotos.length)} / {allWeddingPhotos.length} photos
          </p>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-close-line text-3xl" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
            className="absolute left-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-3xl" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
            className="absolute right-6 w-12 h-12 flex items-center justify-center text-white hover:text-stone-300 transition-colors z-10 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-3xl" />
          </button>

          <div
            className="max-w-6xl max-h-[90vh] px-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={allWeddingPhotos[selectedImage].url}
              alt={allWeddingPhotos[selectedImage].title}
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
            />
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-xs tracking-wider">
            {selectedImage + 1} / {allWeddingPhotos.length}
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-stone-900 text-white py-16 px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-2xl font-extralight tracking-wide mb-2">KAZU.PHOTO</h3>
              <p className="text-xs text-white/60 tracking-wider">
                Photographer / Videografer
              </p>
            </div>
            <Link
              to="/"
              className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Back to Home
            </Link>
          </div>
          <div className="pt-8 mt-8 border-t border-white/10 text-center">
            <p className="text-xs text-white/40">© 2025 KAZU.PHOTO</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
